// extracted by mini-css-extract-plugin
export default {"redButton":"Button_redButton__Pe87m"};